import { FC } from 'react';

import { MessagesWidget } from '~/widgets/MessagesWidget';

import { MFBaseProvider } from '../providers/MFBaseProvider';
import { MFMessagesContextPropsType, MFMessagesProvider } from '../providers/MFMessagesProvider';

const MFMessages: FC<MFMessagesContextPropsType> = (props) => {
  return (
    <MFBaseProvider {...props}>
      <MFMessagesProvider {...props}>
        <MessagesWidget />
      </MFMessagesProvider>
    </MFBaseProvider>
  );
};

export default MFMessages;
